(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tabAccordContent"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    
    function openTab(event, tabId) {
      if (window.innerWidth > 600) {
          const tabButtons = document.querySelectorAll('.tab-button');
          const tabContents = document.querySelectorAll('.tab-content');

          // Remove active class from all tabs and contents
          tabButtons.forEach(function(button) {
              button.classList.remove('active');
          });
          tabContents.forEach(function(content) {
              content.classList.remove('active');
          });

          // Add active class to the clicked tab and corresponding content
          event.currentTarget.classList.add('active');
          document.getElementById(tabId).classList.add('active');
      }
    }

    // Handles accordion toggle
    function toggleAccordion(event, accordionId) {
      if (window.innerWidth <= 600) {
          const accordionButton = event.currentTarget;
          const accordionContent = document.getElementById(`accordion-${accordionId}`);

          // Toggle active state
          accordionButton.classList.toggle('active');
          accordionContent.classList.toggle('active');
      }
    }

    // Adding event listeners to tab buttons
    const tabButtons = document.querySelectorAll('.tab-button');
    tabButtons.forEach(function(button) {
        button.addEventListener('click', function(event) {
            const tabId = event.currentTarget.getAttribute('data-tab-id');
            openTab(event, tabId);
        });
    });

    // Adding event listeners to accordion buttons
    const accordionButtons = document.querySelectorAll('.accordion-button');
    accordionButtons.forEach(function(button) {
        button.addEventListener('click', function(event) {
            const accordionId = event.currentTarget.getAttribute('data-accordion-id');
            toggleAccordion(event, accordionId);
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-testimonial-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Define the openTab function globally
    window.openTab = function(event, tabId) {
      const contents = document.querySelectorAll('.customTestim-tab-content');
      const buttons = document.querySelectorAll('.customTestim-tab-button');

      // Remove active class from all content and buttons
      contents.forEach(content => content.classList.remove('active'));
      buttons.forEach(button => button.classList.remove('active'));

      // Add active class to the current tab and button
      document.getElementById(tabId).classList.add('active');
      event.currentTarget.classList.add('active');
    };

    // Attach click event listeners to all buttons
    const tabButtons = document.querySelectorAll('.customTestim-tab-button');
    tabButtons.forEach(function(button) {
      button.addEventListener('click', function(event) {
        const tabId = button.getAttribute('data-tab-id');
        openTab(event, tabId);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-textSlider"] && !Shopify.designMode) return;
  try {
    
    // Select the logos-slide element
  const logosSlide = document.querySelector(".logos-slide");

  // Clone the content to create a seamless infinite loop
  const copy = logosSlide.cloneNode(true);

  // Append the cloned content after the original content
  document.querySelector(".logos").appendChild(copy);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
